function Footer({noMargin})
{
    return <>
        <div className={`d-flex align-items-center justify-content-center ${noMargin?'':'mt-5'}`} style={{flex:1,backgroundColor:'#e0a923',height:82}}>
            <div style={{color:'white',fontSize:16,fontWeight:600}} className="mx-2">©2023 www.ceosys.co | All Rights Reserved</div>
        </div>
    </>
}
export default Footer;